import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCircleBoothInfo } from '~/features/circle-info/queries/useCircleInfo'
import { useOngoingEventInfo } from '~/features/main/queries/useMainContents'
import TicketHorizontalMobile from '~/shared/assets/images/mobile-ticket-horizontal.png'
import TicketHorizontal from '~/shared/assets/images/ticket-horizontal.png'
import Button from '~/shared/components/buttons/Button'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import Tag from '~/shared/components/tags/Tag'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

function CircleInfo() {
  const navigate = useNavigate()
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium
  const { data: ongoingEvent, isLoading: ongoingEventInfoLoading } =
    useOngoingEventInfo()

  const { data: circleBoothInfo, isLoading: circleBoothInfoLoading } =
    useCircleBoothInfo(ongoingEvent?.id.toString() || '')

  if (ongoingEventInfoLoading || circleBoothInfoLoading)
    return <LoadingScreen />

  return (
    <Wrapper>
      <TicketBox>
        <TicketImage
          src={isMobile ? TicketHorizontalMobile : TicketHorizontal}
          alt="티켓 가로"
        />
        <TicketTitle>{ongoingEvent?.name}</TicketTitle>
        {!isMobile && (
          <TicketInfoBox>
            <div>{ongoingEvent?.show_date}</div>
            <div></div>
            <div>{ongoingEvent?.place}</div>
          </TicketInfoBox>
        )}

        <CircleApplyButton
          $width={117}
          $height={174}
          $fontSize={24}
          $variant="black"
          onClick={() => navigate('/circle-participation/apply')}
        >
          서클참가 신청
        </CircleApplyButton>
      </TicketBox>
      {circleBoothInfo?.list.map((info) => (
        <Card key={info.id}>
          <CardTitle>{info.category}</CardTitle>
          <Body dangerouslySetInnerHTML={{ __html: info.body || '' }} />
          {info.list.map((item) => (
            <InfoItem key={item.idx}>
              <Tag $size={'md'} $variant="gray">
                {item.title}
              </Tag>
              <Body dangerouslySetInnerHTML={{ __html: item.body || '' }} />
            </InfoItem>
          ))}
        </Card>
      ))}
      <CircleApplyButtonFull
        $width={117}
        $height={174}
        $fontSize={24}
        $variant="black"
        className="center"
        onClick={() => navigate('/circle-participation/apply')}
      >
        서클참가 신청
      </CircleApplyButtonFull>
    </Wrapper>
  )
}

export default CircleInfo

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;

  box-sizing: border-box;
  width: 100%;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);

  /* margin: 0 auto; */
  margin-top: 146px;

  @media ${theme.device.large} {
    width: 100%;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    width: 100%;
  }
`

const TicketTitle = styled.span`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  line-height: 140%;
  color: #313634;

  @media ${theme.device.medium} {
    width: 70%;
    font-size: 21px;
  }
`

const TicketBox = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 16px;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  /* height: 278px; */
  padding: 57px 117px;

  @media ${theme.device.large} {
    gap: 10px;
    height: 100%;

    /* min-height: 168px; */
    padding: 32px 28px;
  }

  @media ${theme.device.medium} {
    height: 100%;
  }
`

const TicketInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const CircleApplyButton = styled(Button)`
  width: 240px;
  height: 58px;

  font-size: 24px;
  color: ${theme.colors.white};

  background-color: ${theme.colors.black};

  &.center {
    margin: 0 auto;
  }

  @media ${theme.device.large} {
    width: 140px;
    height: 41px;
    font-size: 15px;
  }
`

const CircleApplyButtonFull = styled(Button)`
  width: 100%;
  height: 58px;

  font-size: 24px;
  color: ${theme.colors.white};

  background-color: ${theme.colors.black};

  @media ${theme.device.large} {
    font-size: 18px;
  }
`

const TicketImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowDefault};
  top: 0;
  left: 0;

  width: 100%;

  object-fit: cover;
  filter: drop-shadow(6px 7px 8px #c3c3c3);

  @media ${theme.device.large} {
    height: 100%;
  }

  @media ${theme.device.medium} {
    height: 100%;
  }
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 36px 24px;

  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const CardTitle = styled.h2`
  width: 100%;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 44.8px;
  color: #313634;
  word-wrap: break-word;
`

const InfoItem = styled.div`
  display: flex;
  gap: 36px;
  align-items: start;

  @media ${theme.device.large} {
    flex-direction: column;
  }

  @media ${theme.device.medium} {
    flex-direction: column;
  }
`
const Body = styled.div`
  width: 100%;
  font-family: NanumSquareNeo-Regular, sans-serif;

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  table {
    width: 100%;
  }

  pre,
  code {
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  iframe {
    max-width: 100%;
  }
`
